import * as __NgCli_bootstrap_1 from "@angular/platform-browser";
import { enableProdMode } from '@angular/core';
import { AppModule } from './app/app.module';
import * as environment from './environments/environment';
import { APP_CONFIG } from '@content-platform/web-angular-shared-util-configuration';
import { OKTA_AUTH } from '@okta/okta-angular';
import { authenticateAndLoadConfigsBeforeBootstrap, isRootApp, isLocationPR, PRE_BOOTSTRAP_USER_INFO } from '@content-platform/web-angular-shared-data-access-okta-auth2';
import { FEATURE_FLAG_USER_INFO } from '@content-platform/web-angular-shared-data-access-feature-flag-api';
/**
 * Pre-Bootstrap Config Loading
 * - Authenticate user BEFORE Angular bootstrap
 * - Load ALL configs from Secrets Manager BEFORE Angular bootstrap
 * - Bootstrap Angular with configs already available
 * - No app-level service changes needed
 */
// Enable production mode if needed
if (environment.production) {
    enableProdMode();
}
// Project name - must match the folder name in apps/ directory
// This is used for:
// - Local config path: /mip2/config/config.json
// - Secrets Manager lookup: Mapped via projects-map.ts → 'mip2' → vcap-configs-mip2
const APP_NAME = 'mip2';
// Calculate BASE_HREF (matches app.module.ts)
const BASE_HREF = isLocationPR() || isRootApp() || window.location.origin.includes('localhost')
    ? ''
    : '/mip2';
// Authenticate and load configs BEFORE bootstrapping Angular
authenticateAndLoadConfigsBeforeBootstrap(APP_NAME, BASE_HREF)
    .then(({ oktaAuth, configs, userInfo }) => {
    console.log('✅ Configs loaded before bootstrap:', Object.keys(configs));
    console.log('✅ User info loaded before bootstrap:', userInfo?.email);
    const mergedConfig = {
        ...configs,
        version: environment.version,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        aspera_credentials: {
            userName: environment.aspera_uid,
            pwd: environment.aspera_pwd
        },
    };
    __NgCli_bootstrap_1.platformBrowser([
        {
            provide: APP_CONFIG,
            useValue: mergedConfig,
        },
        {
            provide: OKTA_AUTH,
            useValue: oktaAuth
        },
        {
            provide: PRE_BOOTSTRAP_USER_INFO,
            useValue: userInfo
        },
        {
            provide: FEATURE_FLAG_USER_INFO,
            useValue: userInfo
        }
    ])
        .bootstrapModule(AppModule)
        .catch((err) => console.error('Error bootstrapping mip2:', err));
})
    .catch((error) => {
    if (error.message && error.message.includes('redirecting to login')) {
        console.log('Redirecting to Okta login...');
        return;
    }
    console.error('Failed to authenticate or load configs:', error);
});
//# sourceMappingURL=main.js.map